import { MeetingAttendeeJoinState } from '@crew/enums/domain'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// TODO: 暫定的にここに定義しているが、定義箇所は変えた方が良さそう。API側にも同じ内容の別定義があるのでそれも統一させる
// https://break-tmc.atlassian.net/browse/CREW-6905
export type MediaPipeline = {
  mediaPipelineArn: string
  mediaPipelineId: string
}

type WebMeetingStateType = {
  isEndMeeting: boolean
  joinState: MeetingAttendeeJoinState | null
}

const initialWebMeetingState: WebMeetingStateType = {
  isEndMeeting: false,
  joinState: null,
}

export const webMeetingSlice = createSlice({
  name: 'webMeeting',
  initialState: initialWebMeetingState,
  reducers: {
    // 会議からの退室判定
    setIsEndMeeting: (state, action: PayloadAction<boolean>) => {
      state.isEndMeeting = action.payload
    },

    setJoinState: (state, action: PayloadAction<MeetingAttendeeJoinState>) => {
      state.joinState = action.payload
    },
  },
})

export const { setIsEndMeeting, setJoinState } = webMeetingSlice.actions
